import { Breadcrumb, Button, Divider, Flex, Typography } from 'antd';

import useModalControls from 'hooks/useModalControls';
import {
  SETTLEMENT_OFFER_STATES,
  SETTLEMENT_OFFER_TYPES,
} from 'utilities/constants';

import ActiveOfferCard from './ActiveOfferCard';
import CancelPlanModal from './CancelPlanModal';
import ScheduledPaymentsTable from './ScheduledPaymentsTable';
import ThirdPartyAlerts from '../ThirdPartyAlerts';

import OfferSetupGrid from '../OfferSetupGrid';
import { useRecoveriesState } from './recoveriesState';

const { Title } = Typography;

const ActiveOffer = ({ thirdParty }) => {
  const cancelPlanModal = useModalControls();
  const { offer } = useRecoveriesState();

  const isPifOffer = offer?.offerType === SETTLEMENT_OFFER_TYPES.PIF;

  const isPendingCloseOutOrFulfilled =
    offer?.state === SETTLEMENT_OFFER_STATES.PENDING_CLOSE_OUT ||
    offer?.state === SETTLEMENT_OFFER_STATES.FULFILLED;

  const SETTLEMENT_STATE_TEXT = {
    [SETTLEMENT_OFFER_STATES.PENDING_CLOSE_OUT]: 'Pending Close Out',
    [SETTLEMENT_OFFER_STATES.FULFILLED]: isPifOffer
      ? 'Paid in Full'
      : 'Settled in Full',
    [SETTLEMENT_OFFER_STATES.IN_PROGRESS]: 'Active Offer',
  };

  return (
    <>
      <Breadcrumb
        style={{ marginBottom: 'var(--spacing-lg)' }}
        items={[
          { title: 'Recoveries Home' },
          { title: SETTLEMENT_STATE_TEXT[offer?.state] },
        ]}
      />

      <ThirdPartyAlerts
        thirdParty={thirdParty}
        hidePrompt={isPendingCloseOutOrFulfilled}
      />

      <OfferSetupGrid>
        <Flex vertical={true}>
          <Title level={5}>{SETTLEMENT_STATE_TEXT[offer?.state]}</Title>
          <ActiveOfferCard thirdParty={thirdParty} />
          {!isPendingCloseOutOrFulfilled && (
            <>
              <Button
                danger
                type="text"
                style={{ marginTop: 'var(--spacing-sm)', float: 'right' }}
                onClick={cancelPlanModal.show}
              >
                Cancel Plan
              </Button>
              <CancelPlanModal {...cancelPlanModal} />
            </>
          )}
        </Flex>
        <Flex vertical={true}>
          <ScheduledPaymentsTable thirdParty={thirdParty} />
        </Flex>
      </OfferSetupGrid>
    </>
  );
};

export default ActiveOffer;
